<template>
	<EMCoreTemplate category="OSMLife" identity="outstandingRequirementComment" entity="osm_outstanding_req_cmt"></EMCoreTemplate>
</template>
<script type="text/javascript">
	import {EMCoreTemplate} from '@/Adm/components' 
	export default{
		components:{
			EMCoreTemplate
		}	
	}

</script>


// WEBPACK FOOTER //
// src/Adm/EntityManagementLife/containers/OutstandingRequirementComment.vue